import { NgModule } from '@angular/core';

import { SharedModule } from '@app/shared';

import { MatTableModule } from '@angular/material/table';
import { MatSortModule } from '@angular/material/sort';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatInputModule } from '@angular/material/input';
import { MatNativeDateModule } from '@angular/material/core';
import { Utils } from '@src/utils/util';
import { DeployedPackagesDetailsComponent } from '@app/authorized/reports/deployed-packages-details/deployed-details-packages.component';
import { DeployedPackagesDetailsDataComponent } from './deployed-packages-details-data/deployed-packages-details-data.component';
import { DeployedPackagesDetailsFilterComponent } from './deployed-packages-details-filter/deployed-details-packages-filter.component';

@NgModule({
    imports: [SharedModule, MatTableModule, MatSortModule, MatDatepickerModule, MatInputModule, MatNativeDateModule],
    declarations: [DeployedPackagesDetailsComponent,DeployedPackagesDetailsFilterComponent,DeployedPackagesDetailsDataComponent],
    entryComponents: [DeployedPackagesDetailsComponent],
    exports: [DeployedPackagesDetailsComponent],
    providers: [MatDatepickerModule, MatNativeDateModule, Utils]
})
export class DeployedPackagesDetailsModule {
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/authorized/reports/deployed-packages-details/deployed-packages-details.module.ts